import { Button } from "@/components/ui/button"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import FormBox from "@/features/shared/components/FormBox"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import TextInputElement from "../../../../components/input/v1/TextInputElement"
import { EMAIL_REGEX } from "../../../../utils/Constants"

interface Props {
    onSubmit: (inputData: { [key: string]: string }) => void;
    emailErrorText: string,
}

const ForgotPasswordBox: React.FC<Props> = ({
    onSubmit,
    emailErrorText,
}) => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()

    const [errorText, setErrorText] = useState(emailErrorText)

    const [inputs, setInputs] = useState<{ [key: string]: string }>({
        email: '',
    });

    const isEmailAcceptable = EMAIL_REGEX.test(inputs.email)
    const isConfirmButtonEnabled = isEmailAcceptable

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        // Ensure the value is in lowercase for the email field
        const formattedValue = name === "email" ? value.toLowerCase() : value;

        setErrorText("")

        setInputs((prev) => ({
            ...prev,
            [name]: formattedValue,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(inputs);
    }

    const handleForgotEmail = async () => {
        navigate("/forgot-email")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "forgot_email" },
        });
    }

    useEffect(() => {
        setErrorText(emailErrorText)
    }, [emailErrorText])

    // ********************************************************************************

    return (
        <FormBox
            title="Password dimenticata"
            description="Inserisci l'e-mail del tuo account e ti invieremo un codice nella casella e-mail per reimpostare la password"
            formContent={
                <>
                    <TextInputElement
                        name="email"
                        label="Indirizzo e-mail"
                        placeholder="mail@sconosciuta.com"
                        errorText={errorText}
                        inputValue={inputs.email}
                        onChange={handleInputChange}
                    />
                    <Button
                        size={'form'}
                        disabled={!isConfirmButtonEnabled}
                    >
                        Invia e-mail
                    </Button>
                </>
            }
            actionButton={
                <Button variant={'white'} size={'form'} onClick={handleForgotEmail}>
                    Hai dimenticato l'indirizzo e-mail?
                </Button>
            }
            onSubmit={handleSubmit}
        />
    )
}

export default ForgotPasswordBox
